/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    /* KL nav-build-c: the address is updated BEFORE rendering, so a render
       served from the cache (synchronous) reads the new order, not the old. */
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    KlOrder.apply();

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    /* KL nav-build-d: the narrowing row (and its copy inside the phone sheet)
       is re-rendered from the fetched section so pressed states and counts
       follow the result. The row is its own <facet-filters-form>, so it is
       swapped whole (a fresh element re-binds its input listener). */
    ['.kl-narrow--row', '.kl-narrow--sheet'].forEach((selector) => {
      const fresh = html.querySelector(selector);
      const current = document.querySelector(selector);
      if (!fresh || !current) return;
      current.replaceWith(fresh.cloneNode(true));
    });
    document.dispatchEvent(new CustomEvent('kl:narrow-rendered'));
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});

/* KL nav-build-c (requirement 01, DECISIONS 6.47): the order control.
   The collection's hand-set (manual) order IS newest-first by release date
   (the drop worker keeps it so). Shopify cannot serve that order reversed, so
   "oldest first" (?kl_order=oldest) is done here: read the page count the
   server printed on #product-grid (it reflects any active narrowing), fetch
   the LAST page with the same narrowing, reverse it, put it in the grid, and
   tell the endless scroll to walk downwards from there. Newest-first needs
   nothing. */
class KlOrder {
  static params() {
    return new URLSearchParams(window.location.search);
  }
  static isOldest() {
    /* Only where the page prints the control (a collection held in
       release-date order). A hand-typed ?kl_order=oldest on any other
       collection is ignored rather than reversing an order nobody explained. */
    if (!document.querySelector('select[name="kl_order"]')) return false;
    return KlOrder.params().get('kl_order') === 'oldest';
  }
  static syncControls() {
    const v = KlOrder.isOldest() ? 'oldest' : 'newest';
    document.querySelectorAll('select[name="kl_order"]').forEach((sel) => {
      if (sel.value !== v) sel.value = v;
    });
  }
  static apply() {
    KlOrder.syncControls();
    const root = document.documentElement;
    const grid = document.getElementById('product-grid');
    const pagerNow = document.querySelector('pagination-theme');
    if (!KlOrder.isOldest()) {
      /* Newest-first: release any hold the pager took from a stale class
         (it reads the class in connectedCallback, before this runs) and put
         it back into forward mode from page 2. */
      root.classList.remove('kl-order-oldest', 'kl-order-pending');
      if (pagerNow) {
        pagerNow.klOldest = false;
        pagerNow.klHold = false;
        pagerNow.klDone = false;
        pagerNow.klLastFirstLink = '';
        pagerNow.i = 2;
        if (pagerNow.observer) pagerNow.observer.observe(pagerNow);
        if (typeof pagerNow.maybeLoadNext === 'function') pagerNow.maybeLoadNext();
      }
      return;
    }
    root.classList.add('kl-order-oldest');
    if (!grid || !grid.dataset.klPages) {
      root.classList.remove('kl-order-pending');
      return;
    }
    const pages = parseInt(grid.dataset.klPages, 10) || 1;
    const pager = document.querySelector('pagination-theme');
    if (pager) { pager.klOldest = true; pager.klHold = true; }
    const finish = (columns) => {
      grid.innerHTML = '';
      columns.forEach((c) => grid.appendChild(c));
      grid.querySelectorAll('.lazyload').forEach((image) => {
        if (window.lazySizes) lazySizes.loader.unveil(image);
      });
      if (pager) {
        pager.klOldest = true;
        pager.i = pages - 1;
        pager.klLastFirstLink = '';
        pager.klDone = pages <= 1;
        if (pager.klDone && pager.button) pager.button.classList.add('visually-hidden');
        pager.klHold = false;
      }
      root.classList.remove('kl-order-pending');
      if (pager && !pager.klDone && typeof pager.maybeLoadNext === 'function') pager.maybeLoadNext();
    };
    const reverseOf = (g) => Array.prototype.slice.call(g.querySelectorAll('.column')).reverse();
    if (pages <= 1) {
      finish(reverseOf(grid));
      return;
    }
    root.classList.add('kl-order-pending');
    const sp = KlOrder.params();
    sp.set('section_id', grid.dataset.id);
    sp.set('page', String(pages));
    fetch(`${window.location.pathname}?${sp.toString()}`)
      .then((r) => r.text())
      .then((html) => {
        const g = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
        if (!g) throw new Error('no grid');
        finish(reverseOf(g));
      })
      .catch(() => {
        /* fall back to newest-first rather than a hidden wall */
        root.classList.remove('kl-order-pending', 'kl-order-oldest');
        if (pager) { pager.klOldest = false; pager.klHold = false; }
      });
  }
}
document.addEventListener('DOMContentLoaded', () => { KlOrder.apply(); });
